export const USER_ROLE_ADMIN = 'admin'
export const USER_ROLE_EDITOR = 'editor'
